import { useSelector } from 'react-redux';
import { selectBreadcrumbs } from '../../selectors/breadcrumbs';
import { Breadcrumbs, Breadcrumb } from '../../components/Breadcrumbs';
import * as React from 'react';

interface IBreadcrumbsContainerProps {
  withBackground?: boolean;
}

export const BreadcrumbsContainer: React.FC<IBreadcrumbsContainerProps> = ({ withBackground }) => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  if (!breadcrumbs.length) {
    return null;
  }

  return (
    <Breadcrumbs withBackground={withBackground}>
      {breadcrumbs.map((breadcrumb, key) => (
        <Breadcrumb key={key} {...breadcrumb} />
      ))}
    </Breadcrumbs>
  );
};
